import React, { useState, useEffect } from "react";
import ReactPlayer from 'react-player'

export default function MonitoringPlayer({ item }) {
    const [buffering, setBuffering] = useState(false);
    const [hasPlayed, setHasPlayed] = useState(false);
    const [monitoring, setMonitoring] = useState({
        loadedSeconds: 0,
        timestamp: Date.now()
    });

    const handleRestartStream = (transcoderId, computerId) => {
        const stopUrl = `https://${computerId}.oyawatch.com/Transcoder/dashboard/admin/switch-hls.php?id=${transcoderId}&act=3`;
        const startUrl = `https://${computerId}.oyawatch.com/Transcoder/dashboard/admin/switch-hls.php?id=${transcoderId}&act=1`;
        
        const stopWindow = window.open(stopUrl, '_blank');
        setTimeout(() => {
            stopWindow.close();
        }, 1000);

        const startWindow = window.open(startUrl, '_blank');
        setTimeout(() => {
            startWindow.close();
        }, 1500);
    }

    const handleCheck = () => {
        const timeDifference = Date.now() - monitoring?.timestamp;
        if ((timeDifference > 120 && hasPlayed === false) || (timeDifference > 120 && !buffering)) {
            console.log('Restarted: ', timeDifference, item.name);
            //handleRestartStream(item.transcoder_id, item.stream_url.split('.')[0].split('https://')[1]);
        }
    }

    useEffect(() => {
        handleCheck();
    }, [monitoring]);

    useEffect(() => {
        const interval = setInterval(() => {
            handleCheck();
        }, 120 * 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <ReactPlayer
                url={item.stream_url}
                playing={true}
                controls={true}
                muted={true}

                onProgress={(progress) => {
                    const loadedSeconds = Math.round(progress.loadedSeconds);
                    if (monitoring?.loadedSeconds !== loadedSeconds) {
                        const monitoringObject = {
                            loadedSeconds: loadedSeconds,
                            timestamp: Date.now(),
                        }
                        setMonitoring(monitoringObject);
                    }
                }}
                onReady={() => {
                    setBuffering(false);
                    setHasPlayed(true);
                }}
                onBuffer={() => setBuffering(true)}
                onBufferEnd={() => setBuffering(false)}
                width={"100%"}
                height={"auto"}
                style={{ boxSizing: 'border-box', overflow: 'hidden' }}
            />
            <div style={{ color: '#fff', fontSize: '6pt', textAlign: 'center', padding: 0, }}>{item.name.trim()}</div>
        </div>
    );
}